<div *ngIf="translateService.currentLang==='en'">
    <div id="main-content" class="highlighted-container container">
        <div class="row">
            <div class="highlighted">  
                <div class="region region-highlighted">
                    <div data-drupal-messages-fallback="" class="hidden"></div>
                    <h1 class="page-header">
                        <span>A Leader in Retail Automotive Leasing</span>
                    </h1>
            </div>
            </div>
        </div>
    </div>
    
    <div role="main" class="main-container container js-quickedit-main-content">
        <div class="row">
            <section class="col-sm-9">
                <div class="region region-content">
                    <article data-history-node-id="2" class="page full clearfix">
                        <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                                <p class="big green"><strong>Since 2011, CDLSI has been providing innovative, robust and secure leasing solutions, delivered with excellent customer experience.</strong></p><p><strong>We are proud to be a leader in Canada's retail automotive industry.</strong> We are a top provider of white label leasing solutions in Canada’s retail automotive industry.</p>
                                <p class="red"><strong>What We Do</strong></p>
                                    <ul>
                                        <li><strong>Manage</strong> vehicle lease portfolio from inception to end of lease</li>
                                        <li><strong>Answer</strong> queries from lessees regarding their vehicle lease contract</li>
                                        <li><strong>Assist</strong> with account management such as updating banking information and change of address</li>
                                        <li><strong>Coordinate</strong> lease returns and vehicle inspections</li>
                                        <li><strong>Collaborate and liaise with dealers</strong><br>&nbsp;</li>
                                    </ul>
                                <p>
                                <a class="btn btn-secondary" routerLink="/contact-us">Provide Feedback</a></p><img class="img-responsive align-center" src="./assets/images/pics/AboutUs.jpg" data-entity-uuid="2e95b1ea-e211-440f-9be3-264e6383ae56" data-entity-type="file" alt="" width="1500" height="844" loading="lazy">
                                <h2 class="big green">At CDLSI, the health, safety, and well-being of our clients and our employees is our number one priority.</h2>
                                <p>In prioritizing customer satisfaction, we are fully available to support our customers. Our office is not open to the public. You can contact us&nbsp;
                                    <a routerLink="/contact-us">here</a>.&nbsp;
                                </p>
                            </div>
                        </div>
                    </article>
                </div>
            </section>
            <aside class="col-sm-3">
                <div class="region region-sidebar-second">
                    <section id="block-aboutussidebar" class="block block-block-content clearfix">
                        <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item"><h2 class="red">Quick Links</h2>

                            <ul class="no-bullets">
                                <li class="hide-faq-link"><a routerLink="/lessees-faq">Frequently Asked Questions</a></li>
                                <li><a routerLink="/contact-us">Contact Information</a></li>
                                <li><a routerLink="/customer-intent">Submit Lease End Intent</a></li>
                            </ul>
                        </div>     
                    </section>
                </div>
            </aside>
        </div>
    </div>
</div>

<div *ngIf="translateService.currentLang==='fr'">
    <div id="main-content" class="highlighted-container container">
        <div class="row">
            <div class="highlighted">  
                <div class="region region-highlighted">
                <div data-drupal-messages-fallback="" class="hidden"></div>
                    <h1 class="page-header">
                        <span>Un chef de file de la location automobile au détail</span>
                    </h1>  
                </div>
            </div>
        </div>
     </div>
  
    <div role="main" class="main-container container js-quickedit-main-content">
      <div class="row">
        <section class="col-sm-9">
            <div class="region region-content">
                <article data-history-node-id="2" class="page full clearfix">
                    <div class="content">
                        <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <p class="big green"><strong>Depuis 2011, CDLSI fournit des solutions de location innovantes, solides et sécurisées, accompagnées d’une excellente expérience client.</strong></p>
                            <p><strong>Nous sommes fiers d’être un chef de file du secteur de l’automobile de détail au Canada.</strong> Nous sommes l’un des principaux fournisseurs de solutions de location de marques blanches dans le secteur automobile de détail au Canada.</p>
                            <p class="red"><strong>Ce que nous faisons</strong></p>
                            <ul>
                                <li><strong>Nous gérons</strong> un portefeuille de location de véhicules du début à la fin du bail</li>
                                <li><strong>Nous répondons</strong> aux questions des locataires concernant leur contrat de location de véhicule</li>
                                <li><strong>Nous aidons</strong> avec la gestion de compte, comme la mise à jour des informations ou coordonnées bancaires et le changement d’adresse</li>
                                <li><strong>Nous coordonnons</strong> les retours de location et les inspections des véhicules</li>
                                <li><strong>Nous collaborons et assurons la liaison avec les concessionnaires</strong><br>&nbsp;</li>
                            </ul>
                            <p><a class="btn btn-secondary" routerLink="/contact-us">Fournir des commentaires</a></p>
                            <img class="img-responsive align-center" src="./assets/images/pics/AboutUs.jpg" data-entity-uuid="2e95b1ea-e211-440f-9be3-264e6383ae56" data-entity-type="file" alt="" width="1500" height="844" loading="lazy">
                            <h2>Chez CDLSI, la santé, la sécurité et le bien ­être de nos clients et de nos employés sont notre priorité.</h2>
                            <p>En priorisant la satisfaction de la clientèle, nous sommes entièrement disponibles pour soutenir nos clients. Nos bureaux ne sont pas ouverts au public. 
                                <a routerLink="/contact-us">Contactez-nous.</a>
                            </p>
                        </div>
                    </div>
                </article>
            </div>
        </section>
  
        <aside class="col-sm-3">
            <div class="region region-sidebar-second">
            <section id="block-aboutussidebar" class="block block-block-content clearfix">
                <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                    <h2 class="red">Liens rapides</h2>
                    <ul class="no-bullets">
                        <li class="hide-faq-link"><a routerLink="/lessees-faq">Foire aux questions </a></li>
                        <li><a routerLink="/contact-us">Coordonnées</a></li>
                        <li><a routerLink="/customer-intent">Soumettre intention fin de bail</a></li>
                    </ul>
                </div>
            </section>
            </div>
        </aside>
    </div>
</div>